<template>
  <div>
    <form
      method="post"
      action=""
      @submit.prevent="saveLog(plt)"
      v-for="plt of patientLogTypes"
      :key="logTypeKey(plt)"
    >
      <div class="row no-gutters align-items-end my-3">
        <div v-if="plt.group_id" class="col-12">
          <strong>{{ plt.group_name[authLocale] }}</strong>
        </div>
        <div v-for="item of plt.items" :key="item.id" class="col pr-2">
          <small class="d-block pb-1">{{ item.name[authLocale] }}</small>
          <input class="form-control form-control-sm" @input="logChange(item, $event)" v-if="item.value_type === 'url'">
          <select v-else
            class="custom-select custom-select-sm"
            @change="logChange(item, $event)"
          >
            <option v-for="v of item.admitted_values" :key="v">
              {{ v }}
            </option>
          </select>
        </div>
        <div class="col-auto">
          <button
            type="submit"
            class="btn btn-primary btn-sm svg-sm svg-upper"
            :class="{ 'btn-success disabled': saved === plt.items[0].id }"
          >
            <template v-if="saved === plt.items[0].id">
                <YesIcon></YesIcon>
              {{ $t("saved") }}
            </template>
            <template v-else>
                {{ $t("save") }}
            </template>
          </button>
        </div>
        <div class="w-100"></div>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import YesIcon from '@/components/Icons/Yes'
export default {
  components: {
    YesIcon
  },
  props: {
    patientId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      logs: {},
      saved: null
    }
  },
  computed: {
    ...mapGetters({
      patientLogTypes: 'patientLogType/patientLogTypes',
      authLocale: 'auth/locale'
    })
  },
  methods: {
    ...mapMutations({
      setError: 'alert/setError'
    }),
    async saveLog (logType) {
      try {
        this.saved = logType.items[0].id
        setTimeout(() => {
          this.saved = null
        }, 2000)
        const params = {}
        params.type_group_id = logType.group_id
        params.items = []
        for (const item of logType.items) {
          let value
          if (item.value_type === 'integer') {
            value = parseInt(this.logs[item.id])
          } else if (item.value_type === 'float') {
            value = parseFloat(this.logs[item.id])
          } else if (item.value_type === 'url') {
            value = this.logs[item.id]
          } else {
            return
          }
          params.items.push({
            type: item.id,
            value: value
          })
        }
        const response = await this.axios.post(
          `/api/patients/${this.patientId}/logs`,
          params
        )
        console.log(response)
      } catch (err) {
        this.setError(err)
      }
    },
    logChange (item, event) {
      this.$set(this.logs, item.id, event.target.value)
    },
    logTypeKey (logType) {
      let ret = ''
      for (const item of logType.items) {
        ret += item.id
      }
      return ret
    }
  }
}
</script>
<i18n>
{
  "ka": {
      "save": "შენახვა",
      "saved": "შენახულია"
  },
  "en": {
      "save": "Save",
      "saved": "Saved"
  }
}
</i18n>
